module.exports = __webpack_public_path__ + "static/img/shanghai2.db3ee09.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/shanghai2.jpg
// module id = NUFE
// module chunks = 1